import { useMemo } from 'react';
import { useTheme } from '@/contexts/ThemeContext';

/** Shared, theme-aware token set for the project dashboard panels. */
export const usePanelTheme = () => {
  const { isDark } = useTheme();
  return useMemo(() => (isDark ? {
    isDark: true,
    card: '#111A2E', inner: '#0A1222', border: 'rgba(148,163,184,0.16)',
    text: '#F8FAFC', text2: '#CBD5E1', muted: '#64748B',
    grid: '#1E293B', hover: 'rgba(59,130,246,0.08)',
    accent: '#3B82F6', good: '#10B981', warn: '#F59E0B', bad: '#EF4444',
    violet: '#8B5CF6', teal: '#14B8A6',
    sheen: 'linear-gradient(135deg, rgba(59,130,246,0.14), rgba(139,92,246,0.06))',
  } : {
    isDark: false,
    card: '#FFFFFF', inner: '#F8FAFC', border: 'rgba(15,23,42,0.08)',
    text: '#0F172A', text2: '#334155', muted: '#94A3B8',
    grid: '#E2E8F0', hover: 'rgba(30,78,140,0.05)',
    accent: '#1E4E8C', good: '#059669', warn: '#D97706', bad: '#DC2626',
    violet: '#7C3AED', teal: '#0D9488',
    sheen: 'linear-gradient(135deg, rgba(30,78,140,0.07), rgba(124,58,237,0.04))',
  }), [isDark]);
};

export default usePanelTheme;
